import { render, staticRenderFns } from "./AssocGlobalOfferToAdSetModal.vue?vue&type=template&id=60b3b3b8&"
import script from "./AssocGlobalOfferToAdSetModal.vue?vue&type=script&lang=js&"
export * from "./AssocGlobalOfferToAdSetModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports